module.exports = __webpack_public_path__ + "media/images/cornerstone-logo-transparent-f6cd6521f5245003c8ef673730b39a8c.png";